import { faunaAPI } from "../fauna-api";

export const receiveLineItems = async payload => faunaAPI.callFunction('receive_LineItems', payload);
export const getLineItemsReport = async (payload) => faunaAPI.callFunction('get_LineItems_report', [payload]);